export default __webpack_public_path__ + "static/media/left.8f21ea9c.svg";